import { render } from "./MobileMainContainer.vue?vue&type=template&id=0c08933e&scoped=true&ts=true"
import script from "./MobileMainContainer.vue?vue&type=script&lang=ts"
export * from "./MobileMainContainer.vue?vue&type=script&lang=ts"

import "./MobileMainContainer.vue?vue&type=style&index=0&id=0c08933e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c08933e"]])

export default __exports__